import { Link } from 'react-router-dom';
import { hotLinks } from '@/mocks/homeData';

export default function HotList() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">本周最受欢迎的视频资源</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotLinks.slice(0, 6).map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-xl p-5 hover:shadow-md transition-all duration-300 cursor-pointer border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <span className="shrink-0 px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug">
                {item.title}
              </h3>
              <div className="flex items-center justify-between text-xs text-foreground-400 mt-3 pt-3 border-t border-background-200">
                <span>
                  <i className="ri-eye-line mr-1"></i>{item.views}
                </span>
                <span>
                  <i className="ri-calendar-line mr-1"></i>{item.date}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <Link
          to="/category/dianying"
          className="sm:hidden mt-6 flex items-center justify-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}